import React from "react";

/**
 * A room rendered in its own colours — the same way the mobile app shows it, so
 * an admin looking at a screenshot from a user sees the same chip.
 *
 * `room == null` is a real state, not missing data: a device can belong to no
 * room. It renders as a neutral, NON-clickable "Ungrouped" chip, because there
 * is no room page to navigate to.
 */
export default function RoomChip({ room, onClick, size = "sm" }) {
  const sizing =
    size === "md" ? "text-xs px-2.5 py-1" : "text-[11px] px-2 py-0.5";

  if (!room || !room._id) {
    return (
      <span
        title="This device is not assigned to a room"
        className={`inline-flex items-center rounded-full bg-slate-100 font-medium text-slate-500 ring-1 ring-inset ring-slate-300/50 ${sizing}`}
      >
        Ungrouped
      </span>
    );
  }

  const style = {
    backgroundColor: room.backcolor || "#EEF2FF",
    color: room.color || "#4338CA",
  };

  const className = `inline-flex items-center rounded-full font-semibold whitespace-nowrap ${sizing}`;

  if (!onClick) {
    return (
      <span className={className} style={style}>
        {room.name}
      </span>
    );
  }

  return (
    <button
      type="button"
      onClick={(e) => {
        // Room chips sit inside clickable table rows; without this, clicking the
        // chip would also fire the row's own navigation.
        e.stopPropagation();
        onClick(room);
      }}
      className={`${className} transition-opacity hover:opacity-80`}
      style={style}
    >
      {room.name}
    </button>
  );
}
